<template lang="pug">
  nav#accessibility-nav.container.hidden-xs.hidden-sm(role="navigation")
    .flex
      a.title.pull-left(href="http://ufrn.br" target="_blank" noopener)
        h1(title="Ir para ufrn.br") UFRN
      ul.list.pull-right
        li
          router-link.sr-only-focusable(to="#conteudo" title="Ir para o conteúdo principal")
            span: small Ir para o conteúdo principal
            //- i.fa.fa-desktop
        //- li: a(href="#", title="Ir para ajuste de contraste"): i.fa.fa-adjust
        li: router-link(:to="{ name: 'Sitemap' }", title="Ir para o mapa do site"): i.fa.fa-sitemap
        li: router-link(:to="{ name: 'Contato' }", title="Ir para a página de contato"): i.fa.fa-envelope
    hr#divisor.-normal
</template>

<style lang="scss">
  $acnav-text-color: $color-grey-normal;
  $acnav-bottombar-color: $color-green-light;
  $acnav-link-hover: $color-green-dark;

  #accessibility-nav {
    position: relative;
    height: 50px;
    color: $acnav-text-color;
    display: flex;
    flex-direction: column;

    .flex {

      > .title {
        > h1 {
          @extend %font_bold;
          color: $acnav-text-color;
          font-size: 20px;
          line-height: 50px;
          &:hover { color: $acnav-link-hover }
        }
      }

      > .list {
        list-style: none;
        > li {
          display: inline-block;
          font-size: 18pt;
          line-height: 50px;
          padding: 0 10px;
          color: inherit;
          > a { color: inherit }
          > a:hover { color: $acnav-link-hover }
          &:last-child { padding-right: 0; }
        }
      }

      a:hover, a:visited, a:focus {
        text-decoration: none;
      }

      .sr-only-focusable {
        > span { font-size: 18px; line-height: 30px;  }
        > span { display: none }
        &:focus {
          > span { display: inline-block }
          > i { display: none }
        }
      }
    }

    #divisor.-normal { width: 98%; padding: 1px 0; }
  }
</style>

<script>
export default {
  name: 'accessibility-nav',

  // Âncora
  methods: {
    scrollMeTo (refName) {
      var element = this.$refs[refName]
      var top = element.offsetTop
      window.scrollTo(0, top)
    }
  }
}
</script>



// WEBPACK FOOTER //
// AccessibilityNav.vue?190db7c0